
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...fallback]",
      function () {
        return require("private-next-pages/[...fallback].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...fallback]"])
      });
    }
  